
import { Component, Vue, Watch } from "vue-property-decorator";
import { productService } from "@/services/api/product.service";
import { StorageFilters } from "@/models/entities/storage/storageFilters.interface";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import { getModule } from "vuex-module-decorators";
import NavigationDrawerFilters from "@/components/core/NavigationDrawerFilters.vue";
import StorageCartModule from "@/store/modules/storage/storageCart.module";
import FiltersStorageModule from "@/store/modules/storage/filtersStorage.module";
import AuthModule from "@/store/modules/core/auth.module";
import store from "@/store";
import LoadingTypeCard from "@/components/storage/LoadingTypeCard.vue";
import SecondaryTypeCard from "@/components/storage/SecondaryTypeCard.vue";
import MainTypeCard from "@/components/storage/MainTypeCard.vue";
import { AdminUsers } from "@/models/utils/admin-users.interface";
const storageModule = getModule(StorageCartModule, store);
const filtersModule = getModule(FiltersStorageModule, store);
const authModule = getModule(AuthModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");

@Component({
  components: {
    MainTypeCard,
    SecondaryTypeCard,
    NavigationDrawerFilters,
    LoadingTypeCard,
    AppBar,
    AppFooter,
  },
})
export default class Storage extends Vue {
  private updateDate = "06/06/2021";
  private drawer = true;
  private updateTime = "15:12";
  private numberSelected = 0;
  private currentSavedElements: StorageElements[] = [];
  private elementsList: StorageElements[] = [];
  private visiblePrice = true;
  private toggle_buttons = 0;
  private isLoading = false;
  public page = 1;
  private currentFilters: StorageFilters = null;
  public numberRecord = 36;
  private itemsLength = 1;
  private savedKeywords: string[] = [];
  private userName = "";
  private adminUsers = AdminUsers;
  private updateHeight = false;
  private srcArticles = false;

  @Watch("drawer")
  triggerUpdateHeight(): void {
    this.updateHeight = !this.updateHeight;
  }

  mounted(): void {
    try {
      this.getCatalog();
    } catch {
      //err
    }
    this.elementsList = [];
    this.userName = authModule.userName;
    window.addEventListener("resize", this.onResize);
  }

  beforeDestroy(): void {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize);
  }

  private onResize(): void {
    if (window.innerWidth < 600) {
      this.toggle_buttons = 0;
    }
  }

  private getCatalog(filters: StorageFilters = null, setPagination = false) {
    // add filters in array to show them in cart recap
    this.srcArticles = false;
    this.savedKeywords = [];
    if (setPagination) {
      this.page = 1;
    }
    if (filters == null) {
      //controllo se in storage
      filters = filtersModule.getFilters;
      if (filters == null) {
        //devi selezionare un filtro
        this.elementsList = [];
      } else {
        //eseguo ricerca
        this.currentFilters = filters;
        this.executeSearch(filters, this.page, this.numberRecord);
      }
    } else {
      //eseguo ricerca
      this.currentFilters = filters;
      if (filters.keywords) {
        this.savedKeywords.push(filters.keywords);
      }
      if (filters.keywords2) {
        this.savedKeywords.push(filters.keywords2);
      }
      this.executeSearch(filters, this.page, this.numberRecord);
    }
  }

  private executeSearch(filters: StorageFilters, page, numberRecord) {
    this.isLoading = true;
    this.srcArticles = true;
    var result;
    try {
      if (filters.catalogueSourceID != 12) {
        result = productService.getProducts(filters, page, numberRecord);
      } else {
        result = productService.getChains(filters, page, numberRecord);
      }

      result.then((res) => {
        //set utils
        this.itemsLength = res.data.length;
        res.data.data.forEach((x) => {
          x.expand = false;
          x.qtySelected = 0;
          x.isInCart = false;
          x.isDifferent = false;
          x.dialog = false;
        });
        this.elementsList = res.data.data;
        // Because some SnowChains have this code...
        //   this.elementsList = res.data.data.filter(
        //     (x) => x.art_Codice != "Codice mancante"
        //   );

        this.updateSelected();
        this.getSelectedElements();
        this.setElementsValue();
        this.isLoading = false;
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    } catch (e) {
      this.isLoading = false;
    }
  }

  private updatePagination(page: number, itemsPerPage: number) {
    this.page = page;
    this.numberRecord = itemsPerPage;
    this.getCatalog();
  }

  private getSelectedElements(): void {
    this.currentSavedElements = storageModule.cart;
  }

  private setElementsValue(): void {
    this.currentSavedElements.forEach((element) => {
      const current = this.elementsList.filter(
        (x) => x.art_Codice == element.art_Codice && element.itemID == x.itemID
      );
      if (current.length == 1) {
        current[0].qtySelected = element.qtySelected;
        current[0].oldValueSelected = element.qtySelected;
        current[0].isInCart = true;
      }
    });
  }

  private updateSelected(): void {
    this.numberSelected = storageModule.count;
  }

  private onlyMoreThanFour = false;
  private changeOnlyMoreThanFour(newValue = false): void {
    this.onlyMoreThanFour = newValue;
  }

  private async openCertificate(
    code: string,
    certificate: string
  ): Promise<void> {
    var result = await productService.getCertificate(
      code,
      certificate,
      filtersModule.getFilters.catalogueSourceID || -1
    );
    if (result.data.value != "") {
      const linkSource = `data:application/pdf;base64,${result.data.value}`;
      const downloadLink = document.createElement("a");
      const fileName =
        result.data.name != null && result.data.name != ""
          ? result.data.name
          : "file.pdf";

      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }

  private async openCertificateNAD(
    code: string,
    certificate: string
  ): Promise<void> {
    var result = await productService.getCertificateNAD(
      code,
      certificate,
      filtersModule.getFilters.catalogueSourceID || -1
    );
    window.open(result.data, "_blank");
  }
}
